import { useLocale } from '@/hooks/useLocale';
import LocaleLink from '@/components/LocaleLink';
import MaybeLink from '@/components/MaybeLink';
import { FOOTER_EN } from '@/copy/footer-en';
import { FOOTER_AR } from '@/copy/footer-ar';
import './Footer.css';

const LOGO_STACKED = {
  en: '/logos/prinotes-lockup-en-stacked-outlined-on-dark.svg',
  ar: '/logos/prinotes-lockup-ar-stacked-outlined-on-dark.svg',
} as const;

/* Horizontal mono-on-dark lockup used at ≤899px (canvas user-lock 2026-05-25).
 * `<picture><source media>` keeps the swap CSS-free + no-JS + no hydration
 * mismatch (Decisions §Q11). */
const LOGO_HORIZONTAL = {
  en: '/logos/prinotes-lockup-en-horizontal-mono-on-dark.svg',
  ar: '/logos/prinotes-lockup-ar-horizontal-mono-on-dark.svg',
} as const;

export default function Footer() {
  const { locale, strings } = useLocale();
  const copy = locale === 'ar' ? FOOTER_AR : FOOTER_EN;

  return (
    <footer className="mkt-footer" data-pn-theme="dark">
      <div className="mkt-footer__inner">
        <div className="mkt-footer__columns">
          <div className="mkt-footer__brand-stack">
            <LocaleLink to="/" className="mkt-footer__brand-home">
              <picture className="mkt-footer__brand-lockup">
                <source media="(max-width: 899px)" srcSet={LOGO_HORIZONTAL[locale]} />
                <img
                  className="mkt-footer__brand-lockup-img"
                  src={LOGO_STACKED[locale]}
                  alt={strings.nav.home}
                />
              </picture>
            </LocaleLink>
          </div>
          {copy.columns.map((col, ci) => {
            const headerId = `mkt-footer-col-${ci}-${locale}`;
            return (
              <nav
                key={ci}
                className="mkt-footer__col"
                aria-labelledby={headerId}
              >
                <p className="mkt-footer__col-h" id={headerId}>{col.head}</p>
                <ul className="mkt-footer__links">
                  {col.links.map((link, li) => (
                    <li key={li}>
                      <MaybeLink
                        to={link.href}
                        live={link.live}
                        external={link.external}
                        opensModal={link.opensModal}
                        onModalClick={() => console.log('[Phase 1] Cookie modal not yet wired')}
                        className={link.opensModal ? 'mkt-footer__link mkt-footer__link--modal' : undefined}
                      >
                        {link.label}
                      </MaybeLink>
                    </li>
                  ))}
                </ul>
              </nav>
            );
          })}
        </div>
        <div className="mkt-footer__bottom">
          <span>{copy.copyright}</span>
        </div>
      </div>
    </footer>
  );
}
